var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefetch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0483 20.2539C9.88549 20.2539 8.04479 19.5013 6.52621 17.9962C5.00762 16.491 4.24833 14.6603 4.24833 12.5039V11.7231L2.39831 13.5731L1.34448 12.5193L4.99831 8.86546L8.65213 12.5193L7.59831 13.5731L5.74828 11.7231V12.5039C5.74828 14.2411 6.35983 15.717 7.58291 16.9318C8.80599 18.1465 10.2945 18.7539 12.0483 18.7539C12.4624 18.7539 12.8762 18.7087 13.2897 18.6183C13.7031 18.5279 14.1066 18.3924 14.5002 18.2116L15.6252 19.3366C15.0624 19.6391 14.4813 19.8676 13.882 20.0221C13.2826 20.1766 12.6714 20.2539 12.0483 20.2539ZM18.9983 16.1423L15.3445 12.4885L16.3983 11.4347L18.2483 13.2847V12.5039C18.2483 10.7667 17.6368 9.29073 16.4137 8.07598C15.1906 6.86123 13.7022 6.25386 11.9483 6.25386C11.5342 6.25386 11.1204 6.29905 10.707 6.38943C10.2935 6.47982 9.88998 6.61539 9.49638 6.79616L8.37141 5.67121C8.93423 5.36864 9.51531 5.14012 10.1147 4.98563C10.714 4.83115 11.3252 4.75391 11.9483 4.75391C14.1111 4.75391 15.9518 5.50646 17.4704 7.01158C18.989 8.51671 19.7483 10.3475 19.7483 12.5039V13.2847L21.5983 11.4347L22.6521 12.4885L18.9983 16.1423Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefetch);
export default __webpack_public_path__ + "static/media/refetch.a008dca76f4270d86c2689d62893fc08.svg";
export { ForwardRef as ReactComponent };